<div class="oiab" *ngIf="visible" role="region" aria-label="Open in the LumberLinq app">
  <i class="pi" [ngClass]="platform === 'ios' ? 'pi-apple' : 'pi-android'"></i>
  <span class="oiab-title">Open in the LumberLinq app</span>
  <button type="button" class="oiab-cta" (click)="openInApp()">Open</button>
  <button type="button" class="oiab-close" (click)="dismiss()" aria-label="Dismiss">
    <i class="pi pi-times"></i>
  </button>
</div>
